import { render, staticRenderFns } from "./Bookkept.vue?vue&type=template&id=5fab7dca&scoped=true&"
import script from "./Bookkept.vue?vue&type=script&lang=ts&"
export * from "./Bookkept.vue?vue&type=script&lang=ts&"
import style0 from "./Bookkept.vue?vue&type=style&index=0&id=5fab7dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab7dca",
  null
  
)

export default component.exports